var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrlOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42927 0.859375H14.5721C14.8882 0.859375 15.1436 1.11473 15.1436 1.4308V14.5737C15.1436 14.8897 14.8882 15.1451 14.5721 15.1451H8.14355C8.06498 15.1451 8.0007 15.0808 8.0007 15.0022V14.0022C8.0007 13.9237 8.06498 13.8594 8.14355 13.8594H13.8578V2.14509H2.14355V7.85938C2.14355 7.93795 2.07927 8.00223 2.0007 8.00223H1.0007C0.922124 8.00223 0.857838 7.93795 0.857838 7.85938V1.4308C0.857838 1.11473 1.1132 0.859375 1.42927 0.859375ZM5.47748 9.56295L4.54534 8.63081C4.52646 8.61183 4.51328 8.58793 4.5073 8.56184C4.50133 8.53574 4.5028 8.5085 4.51154 8.48319C4.52028 8.45789 4.53595 8.43555 4.55677 8.41871C4.57758 8.40188 4.6027 8.39122 4.62927 8.38795L7.83284 8.01295C7.92391 8.00223 8.00248 8.07902 7.99177 8.17188L7.61677 11.3754C7.60248 11.4933 7.45784 11.5433 7.37391 11.4594L6.4382 10.5237L1.8632 15.0987C1.80784 15.154 1.71677 15.154 1.66141 15.0987L0.904267 14.3415C0.848909 14.2862 0.848909 14.1951 0.904267 14.1397L5.47748 9.56295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlOpen);
export default __webpack_public_path__ + "static/media/urlOpen.2f655025b5455d68f0709f8ae5d90a7a.svg";
export { ForwardRef as ReactComponent };